import React from "react";
import styles from "./style.module.css";
import Typography from "../../components/Typography/Typography";
import { ShowcaseImageBottom, ShowcaseImageMiddle, ShowcaseImageTop } from "../../assets/webp";
import AnimatedButton from "../../components/AnimatedButton";

export const ShowcaseSection: React.FC = () => {
  return (
    <div className={styles.showcaseContainer}>
      <section className={styles.showcaseSection}>
        <div className={styles.textContent}>
          <div className={styles.showcaseHeader}>
            <Typography
              variant="heading2"
              fontFamily="satoshi"
              weight="bold"
              className={styles.title}>
              See Creators Like You, Already Showcased
            </Typography>
          </div>
          <div className={styles.showcaseSubtitle}>
            <Typography
              variant="bodyRegular"
              fontFamily="satoshi"
              weight="regular"
              className={styles.subtitle}>
              Creators across the world are turning their product into stunning
              virtual stores. With just one image, you can preview your own space
              and start sharing your story with the world
            </Typography>
          </div>
          <div className={styles.ctaButtonContainer}>
            <AnimatedButton
              variant="primary"
              onClick={() => {
          window.location.href = '/create-store';
        }}
              className={styles.ctaButton}>
              <Typography
                variant="buttonText"
                fontFamily="satoshi"
                weight="bold"
                size="base"
                className={styles.createStoreText}>
                Create Store
              </Typography>
            </AnimatedButton>
          </div>
        </div>
        <div className={styles.imageStack}>
          <img
            src={ShowcaseImageTop}
            alt="Gallery 1"
            width={412}
            height={412}
            className={`${styles.image} ${styles.imageTop}`}
          />
          <img
            src={ShowcaseImageMiddle}
            alt="Gallery 2"
            width={382}
            height={492}
            className={`${styles.image} ${styles.imageMiddle}`}
          />
          <img
            src={ShowcaseImageBottom}
            alt="Gallery 3"
            width={565}
            height={322}
            className={`${styles.image} ${styles.imageBottom}`}
          />
        </div>
      </section>
    </div>
  );
}
